import { useEffect, useState } from "react";
import { Box, CircularProgress, Divider, Paper, TableContainer, Typography } from "@mui/material";
import { useOktaAuth } from "@okta/okta-react";
import { FormattedDataGrid } from "../utils/FormattedDataGrid";

const WSU_RED = "#A60F2D";

export const ActivityLog = ({ userId }) => {
  const [state, setState] = useState({ isLoaded: false, data: null, error: null });
  const { authState } = useOktaAuth();

  useEffect(() => {
    if (!authState || !authState.accessToken) return;

    fetch(`${process.env.REACT_APP_AWS_API_GATEWAY_ENDPOINT}/user/logs/action`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: authState.accessToken.accessToken,
      },
      body: JSON.stringify({ username: userId }),
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Server error: ${res.statusText}`);
        return res.json();
      })
      .then(
        (result) => setState({ data: result.data || [], isLoaded: true, error: null }),
        (error) => setState({ data: null, isLoaded: true, error })
      );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    { field: "id", headerName: "ID", headerClassName: "wsu-theme-header", headerAlign: "center", align: "center", width: 150, hide: true },
    { field: "username", headerName: "User Name", headerClassName: "wsu-theme-header", headerAlign: "center", align: "center", width: 250 },
    { field: "event_action", headerName: "Event Action", headerClassName: "wsu-theme-header", headerAlign: "center", align: "center", width: 150 },
    { field: "event_actor", headerName: "Event Actor", headerClassName: "wsu-theme-header", headerAlign: "center", align: "center", width: 250 },
    { field: "event_comment", headerName: "Comment", headerClassName: "wsu-theme-header", headerAlign: "center", align: "center", width: 200 },
    { field: "event_process", headerName: "Process", headerClassName: "wsu-theme-header", headerAlign: "center", align: "center", width: 150 },
    { field: "event_time", headerName: "Event Time", headerClassName: "wsu-theme-header", headerAlign: "center", align: "center", width: 250 },
  ];

  if (!state.isLoaded) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight={300}>
        <CircularProgress style={{ color: WSU_RED }} size={80} thickness={5} />
      </Box>
    );
  }

  if (state.error) {
    return (
      <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Box sx={{ backgroundColor: WSU_RED, color: "white", px: 3, py: 2 }}>
          <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 0.5 }}>
            Failed to load activity log
          </Typography>
          <Typography variant="body2">{state.error.message}</Typography>
        </Box>
      </TableContainer>
    );
  }

  if (!state.data || state.data.length === 0) {
    return (
      <TableContainer component={Paper} elevation={2} sx={{ borderRadius: 2, overflow: "hidden" }}>
        <Box sx={{ px: 3, pt: 3, pb: 1 }}>
          <Typography variant="overline" sx={{ color: WSU_RED, fontWeight: 700, letterSpacing: 1.5 }}>
            Tech Tools Action History
          </Typography>
        </Box>
        <Box sx={{ px: 3, py: 2 }}>
          <Typography variant="body2" color="text.disabled" fontStyle="italic">
            No records found
          </Typography>
        </Box>
      </TableContainer>
    );
  }

  return (
    <FormattedDataGrid columns={columns} rows={state.data} headerText="Tech Tools Action History" />
  );
};
